import ComponentModule from "@eisinc/Overrides/Components/LocationGoogleMap";

export * from "@eisinc/Overrides/Components/LocationGoogleMap";

export default ComponentModule;
